module.exports = __webpack_public_path__ + "static/media/woocommerce-logo.b1f27412.png";